import React from 'react'
import CustomLayout from 'components/layout-components/CustomLayout'
import AppViews from 'views/app-views'

const AppLayout = () => <CustomLayout views={AppViews} />

export default AppLayout
